import type { AxiosResponse } from 'axios';
import { awCorrelationMatrixApiClient } from './Base';
import type { ComputeAssetCorrelationMatrixRequest, ComputeAssetCorrelationMatrixResponse } from './types';

export function computeAssetCorrelationMatrix(
  request: ComputeAssetCorrelationMatrixRequest,
  signal?: AbortSignal
): Promise<AxiosResponse<ComputeAssetCorrelationMatrixResponse>> {
  const path = 'correlationMatrices:computeAssetCorrelationMatrix';
  return awCorrelationMatrixApiClient.post<ComputeAssetCorrelationMatrixResponse>(path, request, { signal });
}
